(function () {
    /**
     * Get root domain for TLD cookie (e.g., "toms.com" from "us.toms.com")
     * @returns {string}
     */
    function getRootDomain() {
      const hostname = window.location.hostname;
      const parts = hostname.split('.');
      return parts.length > 2 ? parts.slice(-2).join('.') : hostname;
    }

    /**
     * Set cookie on TLD so it's shared across all subdomains
     * @param {string} name
     * @param {string} value
     * @param {number} days
     */
    function setTLDCookie(name, value, days = 365) {
      const rootDomain = getRootDomain();
      const expires = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie = `${name}=${value}; expires=${expires}; path=/; domain=.${rootDomain}; SameSite=Lax`;
    }

    /**
     * Get cookie value by name
     * @param {string} name
     * @returns {string|null}
     */
    function getCookie(name) {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? match[2] : null;
    }

    // Check if user has already been redirected (for homepage auto-redirect only)
    const hasRedirected = getCookie('geo_redirected') === 'true';
    
    // Get stores from window object (populated by Liquid template)
    const stores = window.geoLocationStores || {};
    const allowedCountries = Object.keys(stores);

    if (allowedCountries.length === 0) {
      console.warn('geo-location.js: No stores configured');
      return;
    }

    // Get user's country via Shopify's localization API
    fetch('/browsing_context_suggestions.json')
      .then((response) => response.json())
      .then((data) => {
        const detectedCountry = data.detected_values.country.handle.toUpperCase();
        const currentDomain = window.location.hostname;
        const path = window.location.pathname;
        const targetStore = stores[detectedCountry];
        
        // Only act if country is allowed, targetStore exists, and user is not already on the correct store
        if (allowedCountries.includes(detectedCountry) && targetStore && targetStore.url && !Shopify.designMode) {
          
          if (!targetStore.url.includes(currentDomain)) {
            if (path === '/' && !hasRedirected) {
              // On homepage: auto-redirect
              setTLDCookie('geo_redirected', 'true');
              window.location.href = targetStore.url;
            }
          }
        }
      })
      .catch((err) => console.error('Geolocation detection failed:', err));
})();
